module.exports = __webpack_public_path__ + "static/media/sap-3 1.72e0f02b.png";